<div class="modal-header">
  <h4 class="modal-title" i18n>Payment history</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.close()"></button>
</div>
<div class="modal-body">
  <table class="table table-hover">
    <thead>
      <tr>
        <th class="" i18n>Time</th>
        <th class="" i18n>Type</th>
        <th class="" i18n>Amount</th>
        <th class="" i18n>Status</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngIf="payments.length == 0">
        <td colspan="4" class="text-center" i18n>No transactions.</td>
      </tr>
      <tr *ngFor="let payment of payments">
        <td>
          {{ payment.created_at | date: 'shortDate' }}
          {{ payment.created_at | date: 'shortTime' }}
        </td>
        <td>{{ payment.type | i18nSelect: paymentTypes }}</td>
        <td>{{ payment.amount | currency: organization.currency }}</td>
        <td>{{ payment.status | i18nSelect: paymentStatuses }}</td>
      </tr>
    </tbody>
  </table>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="activeModal.close()" i18n>Close</button>
</div>